<div class="navigation" fxLayout="row" style="align-items: flex-start; align-content: center" vexContainer>
  <vex-navigation-item *ngFor="let item of items" [item]="item"></vex-navigation-item>
</div>